<div class="settings-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12 settings-page__content">
                <div class="settings-card">
                    <div class="settings-card__header">
                        <img src="/assets/images/Group 24.svg" alt="" />
                        <div class="settings-card__header-headline">
                            <h4>Raport Activitate (Detaliat)</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Raport Activitate Detaliat (matrice from → to)</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                [disabled]="!currentFilters" (click)="refreshSearch()" title="Reîmprospătare">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button
                                *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-activitati.matrix.export')"
                                type="button" class="btn btn-sm btn-warning pull-right ms-1"
                                (click)="exportFile('csv')">
                                <i class="fa fa-download"></i>
                                Export CSV
                            </button>
                            <button
                                *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-activitati.matrix.export')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1"
                                (click)="exportFile('pdf')">
                                <i class="fa fa-download"></i>
                                Export PDF
                            </button>
                        </div>
                    </div>

                    <div class="p-3">
                        <app-activity-filters [initialPayload]="initialPayload" [showRegistruType]="false"
                            [viewAllOperators]="true" (search)="onSearch($event)" (reset)="onReset()">
                        </app-activity-filters>

                        <app-matrix-summary-widgets [summary]="summary"></app-matrix-summary-widgets>

                        <app-matrix-from-to-table [rows]="rows" [selectedRow]="selectedRow$ | async"
                            [truncated]="!!matrixResponse?.truncated" (rowClick)="onRowClick($event)"
                            (tipDocumentClick)="onTipChipClick($event)">
                            <ng-container *ngIf="(selectedRow$ | async) && selectedPair" expandedSlot>
                                <app-matrix-drill-down-table *ngIf="currentFilters" [filters]="currentFilters"
                                    [pair]="selectedPair" [tipDocumentFilter]="tipDocumentFilter"
                                    [canViewDocument]="permissionsService.hasPermission('indoc-module.rapoarte-activitati.matrix.view-document')"
                                    (openDocument)="openDoc($event)">
                                </app-matrix-drill-down-table>
                            </ng-container>
                        </app-matrix-from-to-table>

                        <app-matrix-nedistribuite *ngIf="currentFilters" [summary]="nedistribuite"
                            [filters]="currentFilters" [statusMode]="nedistribuiteStatusMode"
                            [canViewDocument]="permissionsService.hasPermission('indoc-module.rapoarte-activitati.matrix.view-document')"
                            (statusModeChange)="onNedistribuiteStatusMode($event)"
                            (openDocument)="openDoc($any($event))">
                        </app-matrix-nedistribuite>
                    </div>

                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>